import { Component, Input } from '@angular/core';
import { Movie } from '@usheru-hff/shared/domain';
/**
 * Component to display the title from a movie.
 *
 * //TODO barbeitoalex propostal - fix title to trTitle
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-movie-title',
  templateUrl: './movie-title.component.html',
  styleUrls: ['./movie-title.component.scss']
})
export class MovieTitleComponent {
  /**
   * @docsNotRequired
   */
  @Input()
  movie: Movie;
}
